import { cn } from "../utils";

type Props = {
  options: {
    label: string;
    value: string;
  }[];
  value: string;
  onChange: (value: string) => void;
};

export default function ToggleGroup({ options, value, onChange }: Props) {
  return (
    <div className="flex items-center gap-1">
      {options.map((option) => (
        <button
          key={option.value}
          className={cn(
            "line-clamp-1 h-9 cursor-pointer rounded-lg px-3",
            value === option.value
              ? "bg-linear-to-r from-primary-100 to-secondary-100"
              : "bg-transparent transition-colors hover:bg-grey-100",
          )}
          onClick={() => onChange(option.value)}
        >
          <span
            className={cn(
              "inline-block text-xs select-none",
              value === option.value
                ? "bg-linear-to-r from-primary-400 to-secondary-400 bg-clip-text font-semibold text-transparent"
                : "font-semibold text-text-secondary",
            )}
          >
            {option.label}
          </span>
        </button>
      ))}
    </div>
  );
}
